import CardPanel from '@/components/CardPanel';
import { FieldType, renderField } from '@/components/FormBuilder';
import { Form, Row, Tree, TreeDataNode } from 'antd';
import { FC } from 'react';

const GROUP_ACCESS_FIELD = [
	{
		name: 'group_name',
		type: 'text',
		label: 'Group Name',
		width: '1/2',
		config: {
			placeholder: 'Input Group Name',
		},
	},
	{
		name: 'group_id',
		type: 'text',
		label: 'Group ID',
		width: '1/2',
		config: {
			placeholder: 'Input Group ID',
		},
	},
	{
		name: 'approval',
		type: 'switch',
		label: 'Approval',
		width: '1/2',
		config: {
			checkedChildren: 'Require',
			unCheckedChildren: 'Not Require',
		},
	},
	{
		name: 'status',
		type: 'switch',
		label: 'Status',
		width: '1/2',
		config: {
			checkedChildren: 'Active',
			unCheckedChildren: 'Incative',
		},
	},
] as FieldType[];

const DUMMY_TREE_DATA: TreeDataNode[] = [
	{
		key: '0',
		title: 'Proses Marketing',
	},
	{
		key: '1',
		title: 'Proses Kredit',
		children: [
			{
				key: '0-0',
				title: 'OCR Rekening Koran',
			},
			{
				key: '0-1',
				title: 'Integrasi API Test',
			},
			{
				key: '0-2',
				title: 'Face Comparation Test',
			},
			{
				key: '0-3',
				title: 'Verifikasi Customer',
			},
		],
	},
	{
		key: '2',
		title: 'Approval',
		children: [
			{
				key: '2-0',
				title: 'Deviasi Marketing',
			},
			{
				key: '2-1',
				title: 'Survey',
			},
			{
				key: '2-2',
				title: 'Order Cabang',
			},
		],
	},
];

const GroupAccessForm: FC = () => {
	return (
		<CardPanel title="Group Access Edit">
			<CardPanel.Content>
				<Form layout="vertical">
					<Row gutter={[16, 16]}>
						{GROUP_ACCESS_FIELD.map((field, key) => {
							return renderField({ ...field, key });
						})}
					</Row>
				</Form>
			</CardPanel.Content>

			<CardPanel.Content title="Access">
				<Tree
					checkable
					treeData={DUMMY_TREE_DATA}
					defaultExpandAll
				/>
			</CardPanel.Content>
		</CardPanel>
	);
};

export default GroupAccessForm;
